// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"869":"89515d98","962":"122c0338"}[chunkId] + ".chunk.css";
};